// Packages
import { useState, useEffect } from "react";
import { toast } from "react-hot-toast";
import { motion } from "framer-motion";
// Components
import JournalCard from "../../Common/Card/JournalCard/JournalCard";
import Slider from "../../Common/Slider/Slider";
// Styles
import Styles from "./Styles/Journal.module.css";
// API
import { getArticles } from "../../../Services/getData";
import ImageArticlesListCard from "../../Common/Card/ImageArticlesListCard/ImageArticlesListCard";

const Journal = ({ handleShareArticle, handleSaveArticle }) => {
  const [itemsPerView, setItemsPerView] = useState(3);
  const [textuals, setTextuals] = useState([]);
  // const [vertical, setVertical] = useState(true);
  useEffect(() => {
    if (window.innerWidth > 700 && window.innerWidth < 1270) {
      setItemsPerView(2);
      // setVertical(true);
    } else if (window.innerWidth < 700) {
      setItemsPerView(1);
      // setVertical(false);
    }
    const api = async () => {
      try {
        const textualsList = await getArticles("visual");
        setTextuals(textualsList.data.article.slice(-8));
      } catch (ex) {
        toast.error(ex.response.data.message);
      }
    };
    api();
  }, []);

  const handleChangePosts = (post) => {
    const copyTextuals = [...textuals];
    const filteredTextuals = copyTextuals.filter(
      (i) => i.category === post.category
    );
    setTextuals(filteredTextuals);
    toast.success(`لیست مقالات متنی بر اساس ${post.category} بروزرسانی شد`);
    return;
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1 }}
      className={Styles.posts}
    >
      <div className={Styles.slider}>
        <Slider
          Card={ImageArticlesListCard}
          itemsPerView={itemsPerView}
          slidesClass="visualSlideContainer"
          // vertical={vertical}
          vertical={false}
          space={30}
          error="مقاله ای یافت نشد"
          data={textuals}
          handleChangePosts={handleChangePosts}
          handleShareArticle={handleShareArticle}
          handleSaveArticle={handleSaveArticle}
        />
      </div>
    </motion.div>
  );
};

export default Journal;
